export default "__VITE_ASSET__Yh1$7uOH__"